<template>
  <v-container>
    <v-form ref="form" v-model="valid" @submit.prevent="verificarDataParcelas">
      <v-list class="pa-0" two-line>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title class="subheading white--text">
            Cotação de Endosso
          </v-toolbar-title>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-card class="pa-2" v-show="endosso.idTipoEndosso !== undefined" >
          <v-layout row wrap >
            <v-flex xs12 sm12 md4 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #bababa; border-radius: 5px"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0">
                  <b>Proposta Auto-Frota</b>
                  <br />
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="
                        padding-top: -15px;
                        margin-top: -5px;
                        padding: 0px;
                        margin: 0px;
                      "
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          style="
                            padding: -20px 0px 0px 0px;
                            margin: -10px 0px 0px 0px;
                          "
                          :disabled="desabilitaBotaoProposta"
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarPropostaoEndossoPdf"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #bababa; border-radius: 5px"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0">
                  <b>Boleto Auto-Frota</b>
                  <br />
                  <b v-if="apoliceNumeroProposta != null && !desabilitaBotaoPdfBoleto">{{apoliceNumeroProposta}}</b>
                  <br v-else/>
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="
                       padding-top: -15px;
                        margin-top: -5px;
                        padding: 0px;
                        margin: 0px;
                      "
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotaoPdfBoleto"
                          style="
                            padding: -20px 0px 0px 0px;
                            margin: -10px 0px 0px 0px;
                          "
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarEndossoBoleto"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #bababa; border-radius: 5px"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0">
                  <b>Apólice Auto-Frota</b>
                  <br />
                  <b v-if="apoliceNumero != null && !desabilitaBotaoPdfEndosso">{{apoliceNumero}}</b>
                  <br v-else/>
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="
                        padding-top: -15px;
                        margin-top: -5px;
                        padding: 0px;
                        margin: 0px;
                      "
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotaoPdfEndosso"
                          style="
                            padding: -20px 0px 0px 0px;
                            margin: -10px 0px 0px 0px;
                          "
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarEndossoApolice"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card class="pa-5">
          <v-flex class="py-1"> Dados do Endosso </v-flex>
          <v-flex class="py-2"></v-flex>
          <v-layout row wrap>
            <v-flex xs12 sm2 md2>
              <v-select
                label="Tipo Seguro"
                :items="apoliceTipoDePropostaList"
                v-model="idTipoDeProposta"
                item-text="titulo"
                item-value="id"
                disabled
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field disabled label="N. Apólice" v-model="apoliceNumero">
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                disabled
                label="Cód. da Cotação do Endosso"
                v-model="codigoEndosso"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                disabled
                label="N. Proposta"
                v-model="apoliceNumeroProposta"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-layout row wrap>
            <v-flex xs12 sm12 md3>
              <v-menu
                ref="menu"
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textAtualizacao"
                    label="Data da Ultima Atualização"
                    prepend-icon="event"
                    readonly
                    disabled
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateAtualizacao" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm12 md3>
              <v-menu
                ref="menu"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                :min-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Inicio Data Vigencia"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :disabled="camposDisabled"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateInicio" no-title scrollable :min="dataAtual">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm12 md3>
              <v-menu
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                :min-width="290"
                disabled
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textFim"
                    label="Fim Data Vigencia"
                    prepend-icon="event"
                    readonly
                    disabled
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFim" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                label="Tipo Endosso"
                :items="tipoEndossoList"
                v-model="idTipoEndosso"
                item-text="titulo"
                item-value="id"
                disabled
              >
              </v-select>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm5 md3>
              <v-text-field
                disabled
                label="Qtd. de dias de vigência"
                v-model="diasVigencia"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md3>
              <v-select
                label="Motivo do Endosso"
                :items="motivoEndossoList"
                v-model="idMotivoEndosso"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>

            <v-spacer></v-spacer>
            <v-flex mb-6 class="textblack">
              Breve descrição sobre o Endosso(Texto Livre)

              <v-flex xs12 sm5 md12>
                <v-textarea
                  v-model="textoLivreEndosso"
                  class="textarea"
                  outline
                  required
                  :rules="[regras.length(7500)]"
                  :readonly="camposDisabled"
                  counter="7500"
                ></v-textarea>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="py-1">Proponente</v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 sm4 md3>
              <v-text-field
                label="Razão Social"
                required
                browser-autocomplete="off"
                :rules="regras.notNull"
                v-model="proponenteRazaoSocial"
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md3>
              <v-select
                label="Tipo Pessoa"
                item-text="titulo"
                item-value="id"
                v-model="idTipoPessoa"
                :items="tipoPessoaList"
                required
                :rules="regras.notNull"
                disabled
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex md3>
              <v-text-field
                :mask="
                  this.idTipoPessoa === 1
                    ? '###.###.###-##'
                    : 'NN.NNN.NNN/NNNN-##'
                "
                :label="{ 1: 'CPF', 2: 'CNPJ' }[idTipoPessoa] || 'CPF/CNPJ'"
                browser-autocomplete="off"
                required
                :rules="regras.notNull"
                v-model="proponenteCnpj"
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex v-if="endossoExclusao && !ocultarCamposParaCorretorParceiro" md2>
              <v-btn
                class="button-custom"
                @click="dialogParticipantes = true"
                flat>
                Participantes
              </v-btn>
            </v-flex>
          </v-layout>
          <v-flex v-if="!endossoExclusao && !ocultarCamposParaCorretorParceiro">
            <v-btn
              class="button-custom"
              @click="dialogParticipantes = true"
              flat>
              Participantes
            </v-btn>
          </v-flex>
        </v-card>
      </v-list>

      <v-layout pt-5>
        <v-flex>
          <v-btn
            color="primary"
            @click="
              $router.push(
                `/corretor/endossos?id=${idApolice}&idTipoEndosso=${idTipoEndosso}&idStatusCorretorReserva=${idStatusCorretorReserva}`
              )
            "
            flat
          >
            Voltar
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex>
          <v-btn class="primary" type="submit" :disabled="!valid || disableProximo()">
            Próximo
          </v-btn>
        </v-flex>
      </v-layout>
      <v-snackbar
        :timeout="3000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel"
      >
        {{ snackbar.mensagem }}
        <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-form>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogParticipantes" max-width="1200px">
          <ModalParticipantes
            v-if="dialogParticipantes"
            :dialog="dialogParticipantes"
            @fechar="dialogParticipantes = false"
            :participantes="participanteList"
            :somenteLeitura="true"
          />
        </v-dialog>
      </v-layout>
    </template>
  </v-container>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import formRules from "@/helpers/form-rules.js";
import CustomFormat from "@/helpers/custom-format";
import moment from "moment";
import tipoEndossoEnum from "@/helpers/tipo-endosso-enum.js";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";
import ModalParticipantes from "../frota/ModalParticipantes.vue";
export default {
  name: "InfoEndossoCorretor",

  components: {
    ModalParticipantes
  },

  data: () => ({
    menu: false,
    naoCalcularItens: false,
    desabilitaBotoes: false,
    desabilitaBotaoProposta: true,
    desabilitaBotaoPdfBoleto: true,
    desabilitaBotaoPdfEndosso: true,
    disabled: false,
    apolice: { dateFim: null },
    percCondicaoComercial: null,
    dateInicioEndosso: null,
    dateFimEndosso: null,
    dataAtual: new Date().toISOString().slice(0, 10),
    endosso: {},
    conteudoPlanilha: [],
    numeroRevisao: null,
    idTipoCondicao: null,
    modalEmitirCancelamento: false,
    valid: false,
    activeInfo: false,
    dataRespostaApolice: null,
    aplicCondicao: null,
    parcelamentoList: [],
    formaPagamentoList: [],
    dialogErrorEmitirCancelamento: null,
    enderecoUfList: [],
    numeroApolice: null,
    errorMessage: null,
    proponenteRazaoSocial: null,
    idAplicaCondicao: null,
    idRelacionado: null,
    codigoEndosso: null,
    inicioVigencia: null,
    textFimVigencia: null,
    textInicioVigencia: null,
    idTipoEndosso: null,
    idMotivoEndosso: null,
    motivoEndossoList: [],
    tipoEndossoList: [],
    idPropostaStatus: null,
    errorDetails: null,
    premioTotalEndosso: 0,
    textoLivreEndosso: null,
    valorRestituicao: 0,
    idTipoDeProposta: null,
    proponenteCnpj: null,
    apoliceTipoDePropostaList: [],
    idApoliceModalidade: null,
    idApolice: null,
    dataPrimeiraParcela: (() => {
      const d = new Date()
      d.setDate(d.getDate() + 7)

      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    })(),
    idGatilhoUtilizado: null,
    idParcelamento: 10,
    idFormaPagamento: 3,
    razaoSocialCorretor: null,
    cpfCnpjCorretor: null,
    emailCorretor: null,
    telefoneCorretor: null,
    numeroSusepCorretor: null,
    tipoCorretagemList: [],
    tipoCorretagem: null,
    desabilitaBotaoPdfEndossoBoleto: true,
    desabilitaBotaoPdfEndossoApolice: true,
    valorCorretagem: null,
    apoliceNumeroProposta: null,
    apoliceNumero: null,
    apoliceIof: null,
    corretagem: null,
    diasVigencia: null,
    requisisaoEndosso: {},
    totalPremio: 0,
    totalRestituicao: 0,
    valoresQtdParcelas: null,
    vigenciaInicioText: null,
    idTipoPessoa: null,
    dialogParticipantes: false,
    vigenciaFimText: null,
    ocultarCamposParaCorretorParceiro: true,
    tipoCondicaoList: [
      { id: 1, titulo: "Nenhuma" },
      { id: 2, titulo: "Agravo" },
      { id: 3, titulo: "Desconto" }
    ],
    tipoPessoaList: [
      { id: 1, titulo: "Física" },
      { id: 2, titulo: "Jurídica" }
    ],
    participanteList: [],
    apoliceEndereco: {
      enderecoCep: null,
      enderecoRua: null,
      enderecoNumero: null,
      enderecoComplemento: null,
      enderecoBairro: null,
      enderecoCidade: null,
      enderecoUf: null,
      enderecoTelefone: null,
      enderecoEmail: null
    },
    dateAtualizacao: new Date().toISOString().slice(0, 10),
    dateInicio: new Date().toISOString().slice(0, 10),
    dateFim: new Date().toISOString().slice(0, 10),
    menu1: false,
    menu2: false,
    menu3: false,
    modal: false,
    endossoTipoSubstituicao: false,
    idStatusEndosso: null,
    regras: {
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "CNPJ incorreto"],
      cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"],
      length: len => v =>
        (!!v && (v || "").length <= len) ||
        `Preencha esse campo com no máximo ${len} caracteres.`
    },
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    }
  }),
  async mounted() {
    Object.entries(this.$store.getters["formEndosso/infoEndosso"]).forEach(
      ([key, value]) => {
        if (
          (this[key] instanceof Array &&
            value instanceof Array &&
            !this[key].length) ||
          value !== null
        ) {
          this[key] = value;
        }
      }
    );
    this.idStatusEndosso = parseInt(this.$route.query.idStatusEndosso);
    this.idTipoEndosso = parseInt(this.$route.query.idTipoEndosso);
    this.idApolice = this.$route.query.id;
    this.idStatusCorretorReserva = this.$route.query.idStatusCorretorReserva
      ? this.$route.query.idStatusCorretorReserva
      : null;
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.numeroRevisao = this.$route.query.numeroRevisao;

    if (this.$route.query.corretorParceiro === 'true') {
      this.ocultarCamposParaCorretorParceiro = false;
      await this.buscarApolice();
      await this.buscarEndosso(this.numeroRevisao, this.idRascunhoEndosso);

      if (this.endosso && (this.endosso.codigoEndosso !== undefined || this.endosso.codigoEndosso !== null)) {
        this.getRespostaEndosso();

        if (this.endosso.idStatusEndosso === statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO) {
          this.getRespostaPdfEndossoApolice();
          this.getRespostaPdfEndossoBoleto();
        }
      }
    }

    if(
      this.idTipoEndosso != tipoEndossoEnum.tipoEndosso.GATILHO
    ) {
      if (this.idRascunhoEndosso || this.numeroRevisao ) {
        this.dateInicioEndosso = localStorage.getItem("dateInicio");

        this.$store.commit("startLoading");
        await this.buscarApolice();
        await this.buscarEndosso(
          this.idRascunhoEndosso || this.numeroRevisao,
          this.idRascunhoEndosso
        );
        this.$store.commit("formEndosso/setInfoEndosso", {
          ...this.endosso,
          idRascunhoEndosso: this.idRascunhoEndosso,
        });
        Object.entries(this.$store.getters["formEndosso/infoEndosso"]).forEach(
          ([key, value]) => (this[key] = value)
        );
        this.$store.commit("endLoading");
        this.contarDias(
          new Date(localStorage.getItem("dateFim")),
          new Date(this.dateInicio)
        );
      }
    }

    if (this.percCondicaoComercial) {
      this.percCondicaoComercial = null;
    }

    if (this.numeroRevisao == undefined) {
      await this.buscarApolice();
    }
    this.retornarTipoDeProposta();
    this.buscaOpcoes();
    this.buscarParticipantes();
    this.retornarProponenteCNPJ();
    this.buscarProponenteRazaoSocial();

    if (this.numeroRevisao == undefined) {
      this.retornarTipoPessoa();
    } else {
      this.retornarTipoPessoaEndosso();
    }

    this.botoesDisabled();

    this.desabilitaBotaoProposta = this.validaDesabilitaBotaoProposta();
  },

  computed: {
    endossoExclusao() {
      return this.idTipoEndosso == tipoEndossoEnum.tipoEndosso.EXCLUSAO;
    },
    endossoSubstituicao() {
      return this.idTipoEndosso == tipoEndossoEnum.tipoEndosso.SUBSTITUICAO;
    },
    camposDisabled() {
      return this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO || this.$route.query.corretorParceiro === 'true';
    },

    textAtualizacao() {
      return new Date(this.dateAtualizacao).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },

    condicaoComercial: {
      get() {
        switch (this.idTipoCondicao) {
          case 1:
            return 4;
          case 2:
            if (this.percCondicaoComercial < 0) {
              this.percCondicaoComercial = -this.percCondicaoComercial;
            }
            return +this.percCondicaoComercial;
          case 3:
            if (this.percCondicaoComercial < 0) {
              this.percCondicaoComercial = -this.percCondicaoComercial;
            }
            return -this.percCondicaoComercial;
        }
      },
      set(perc) {
        if (typeof perc === "number") {
          if (perc === 0) {
            this.idTipoCondicao = this.tipoCondicaoList[0].id;
          } else {
            this.percCondicaoComercial = Math.abs(perc);
            this.idTipoCondicao = this.tipoCondicaoList[perc > 0 ? 1 : 2].id;
          }
        }
      }
    },
    textInicio() {
      return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textPrimeiraParcela() {
      return new Date(this.dataPrimeiraParcela).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },

    textFim() {
      let data = new Date(this.dateFim).toISOString().slice(0, 10);
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },

    formRulesComputed() {
      return formRules;
    }
  },
  methods: {
    disableProximo() {
      const revisao = this.endosso.numeroRevisao;
      const tipo = this.endosso.idTipoEndosso;

      return revisao != null && tipo != tipoEndossoEnum.tipoEndosso.COBRANCA;
    },

    preencherCamposEndosso(endosso) {
      this.textoLivreEndosso = endosso.textoLivreEndosso;
      this.idMotivoEndosso = endosso.idMotivoEndosso;
      this.dataPrimeiraParcela = endosso.dataPrimeiraParcela;
      this.idFormaPagamento = endosso.idFormaPagamento;
      this.idParcelamento = endosso.idParcelamento;
      this.contarDias(new Date(endosso.dateFim), new Date(endosso.dateInicio));
      this.codigoEndosso = endosso.idApolice;
      this.idApolice = endosso.idApolice;
      this.numeroRevisao = this.$route.query.numeroRevisao
        ? this.$route.query.numeroRevisao
        : endosso.idEndossoRascunhoSalvo
          ? endosso.idEndossoRascunhoSalvo
          : endosso.idEndosso;
    },

    verificarDataParcelas() {
      if (!this.endossoExclusao) {
        axios
          .get(
            `${process.env.URL_APOLICEMS}/v1/validarDataParcelamento?dataFimPolice=${this.dateFim}&dataInicioParcela=${this.dataPrimeiraParcela}&parcelas=${this.idParcelamento}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            if (response) {
              this.proximaPagina();
            }
          })
          .catch(err => {
            this.snackbar.visivel = true;
            this.snackbar.sucesso = false;
            this.snackbar.mensagem = err.response.data.message;
          });
      } else {
        this.proximaPagina();
      }
    },

    async getRespostaEndosso() {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/buscarRespostaEndosso/${this.idApolice}/${this.codigoEndosso}`,

        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );

      this.idRelacionado = response.data.id_endosso_relacionado;
    },

    validaDesabilitaBotaoProposta() {
      const statusHabilitados = [
        statusEndossoEnum.statusEndosso.EMITIDA,
        statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO,
        statusEndossoEnum.statusEndosso.ENDOSSO_REPROVADO,
        statusEndossoEnum.statusEndosso.CANCELADO,
        statusEndossoEnum.statusEndosso.RECUSADO,
      ];

      return !statusHabilitados.includes(this.endosso.idStatusEndosso);
    },

    async getRespostaPdfEndossoApolice() {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoApolice/${this.idApolice}/${this.endosso.codigoEndosso}`,

        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      response.data
        ? (this.desabilitaBotaoPdfEndosso = false)
        : (this.desabilitaBotaoPdfEndosso = true);
    },
    async getRespostaPdfEndossoBoleto() {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoBoleto/${this.idApolice}/${this.endosso.codigoEndosso}`,

        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      response.data
        ? (this.desabilitaBotaoPdfBoleto = false)
        : (this.desabilitaBotaoPdfBoleto = true);
    },
    botoesDisabled() {
      return this.endosso.idStatusEndosso ==
        statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO
        ? (this.desabilitaBotoes = false)
        : (this.desabilitaBotoes = true);
    },

    async retornarAplicaCondicao() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/retornarAplicaCondicao/${this.numeroRevisao}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idAplicaCondicao = response.data;
    },

    async retornarTipoCondicao() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/retornarTipoCondicao/${this.numeroRevisao}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoCondicao = response.data;
    },

    async retornarPercCondicao() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/retornarPercCondicao/${this.numeroRevisao}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.percCondicaoComercial = response.data;
    },

    gerarCotacaoEndossoPdf() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndosso/${this.idApolice}/${
          this.numeroRevisao
            ? this.numeroRevisao
            : this.endosso.idRascunhoEndosso
        }?tipo=${this.idTipoEndosso}&rascunho=${
          this.$route.query.idStatusEndosso ==
          statusEndossoEnum.statusEndosso.SALVO
            ? true
            : false
        }`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Endosso.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf cotação não localizado";
        });
    },
    gerarPropostaoEndossoPdf() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoProposta/${this.idApolice}/${this.numeroRevisao}?tipo=${this.idTipoEndosso}&premioLiquido=false`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Endosso-proposta.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf proposta não localizado";
        });
    },

    async retornarProponenteCNPJ() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteCnpj/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.proponenteCnpj = response.data;
    },

    async buscarProponenteCnpjEndosso() {
      const url =
        this.idTipoEndosso == 4
          ? `${process.env.URL_APOLICEMS}/v1/retornarProponenteCnpj/${this.idApolice}`
          : `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteCnpjEndosso/${this.numeroRevisao}?status=${this.idStatusEndosso}`;
      var response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      });
      this.proponenteCnpj = response.data;
    },

    async buscarProponenteRazaoSocial() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteRazaoSocial/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.proponenteRazaoSocial = response.data;
    },

    async buscarProponenteRazaoSocialEndosso() {
      const url =
        this.idTipoEndosso == 4
          ? `${process.env.URL_APOLICEMS}/v1/retornarProponenteRazaoSocial/${this.idApolice}`
          : `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteRazaoSocialEndosso/${this.numeroRevisao}?status=${this.idStatusEndosso}`;
      var response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      });
      this.proponenteRazaoSocial = response.data;
    },

    async retornarTipoPessoa() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoPessoa/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoPessoa = response.data;
    },

    async retornarTipoPessoaEndosso() {
      const url = `${process.env.URL_APOLICEMS}/v1/retornarTipoPessoa/${this.idApolice}`;
      var response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      });
      this.idTipoPessoa = response.data;
    },

    gerarEndossoApolice() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoApolice/${this.idApolice}/${this.idRelacionado}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Apolice-endosso- " + this.apolice.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Apólice não localizado";
        });
    },
    gerarEndossoBoleto() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoBoleto/${this.idApolice}/${this.idRelacionado}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Boleto-endosso- " + this.apolice.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Boleto não localizado";
        });
    },
    dataFormatada(data) {
      let dateFim = new Date(data).toISOString().slice(0, 10);
      return new Date(dateFim).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    async buscarApolice() {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/buscarApolice/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );

      this.apolice = response.data;
      this.dateFim = this.apolice.dateFim;
      this.apoliceIof = this.apolice.apoliceIof;
      this.corretagem = this.apolice.corretagem;
      this.apoliceNumeroProposta = this.apolice.apoliceNumeroProposta;
      this.apoliceNumero = this.apolice.apoliceNumero;
      this.contarDias(
        new Date(this.apolice.dateFim),
        new Date(this.apolice.dateInicio)
      );
    },
    async buscarEndosso(idEndosso, rascunho) {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/visualizar${this.visualizarEndosso(
          idEndosso,
          rascunho
        )}/${idEndosso}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.endosso = response.data;
      this.preencherCamposEndosso(this.endosso)
      this.buscarEndereco();

      this.dateInicio = this.endosso.dateInicio;
      this.dateFim = this.endosso.dateFim;
    },
    visualizarEndosso(idEndosso, rascunho) {
      if (rascunho) {
        return "RascunhoEndosso";
      } else if (
        (idEndosso &&
        (this.idStatusEndosso == statusEndossoEnum.statusEndosso.SALVO || this.idStatusEndosso == statusEndossoEnum.statusEndosso.PENDENTE
          || this.idStatusEndosso == statusEndossoEnum.statusEndosso.RECUSADO)
        && this.idTipoEndosso != 4)
      ) {
        return "EndossoSalvo";
      } else {
        return "Endosso";
      }
    },

    async buscarEndereco() {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/buscarEndereco/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.apoliceEndereco = response.data;
    },

    toLocalDateTimeString: function(val) {
      var data = CustomFormat.toLocaleDateTimeString(val);
      return data.slice(0, 10);
    },
    formatDate() {
      if (this.dataRespostaApolice) {
        var formatedDate = moment(this.dataRespostaApolice).format(
          "DD/MM/YYYY"
        );
        return formatedDate;
      }
    },
    contarDias(dateFim, dataInicio) {
      let dias = 1000 * 60 * 60 * 24;
      let inicio = dataInicio.getTime();
      let fim = dateFim.getTime();
      let diasCalculo = Math.abs(fim - inicio);
      this.diasVigencia = Math.round(diasCalculo / dias);
    },
    async retornarTipoDeProposta() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoDeProposta/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoDeProposta = response.data;
    },

    async buscarParticipantes() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/listarParticipantes/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.participanteList = response.data;
    },

    buscaOpcoes() {
      [
        "propostaStatus",
        "propostaTipo",
        "apoliceTipoDeProposta",
        "apoliceModalidade",
        "parcelamento",
        "formaPagamento",
        "proponenteRamoDeAtuacao",
        "enderecoUf",
        "motivoEndosso",
        "tipoEndosso"
      ].forEach(item => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then(response => {
            this[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    onDateChange: function() {
      const self = this;
      const date = self.dateInicio.split("-");
      const ano = parseInt(date[0]) + 1;
      const newDateFim = date.concat(ano + "-" + date[1] + "-" + date[2]);
      this.dateFim = newDateFim[3];
    },

    proximaPagina: function() {
      if (this.$refs.form.validate()) {
        this.atualizarInformacoesEndosso();
        this.redirecionarParaPagina();
      }
    },

    atualizarInformacoesEndosso() {
      this.$store.commit("formEndosso/setInfoEndosso", {
        idAplicaCondicao: this.idAplicaCondicao,
        idTipoDeProposta: this.idTipoDeProposta,
        apoliceNumero: this.apoliceNumero,
        codigoEndosso: this.codigoEndosso,
        apoliceNumeroProposta: this.apoliceNumeroProposta,
        dataUltimaAtualizacao: this.dataUltimaAtualizacao,
        idTipoEndosso: this.idTipoEndosso,
        dateInicio: this.dateInicio,
        dateFim: this.dateFim,
        diasVigencia: this.diasVigencia,
        idMotivoEndosso: this.idMotivoEndosso,
        textoLivreEndosso: this.textoLivreEndosso,
        apoliceEndereco: this.obterApoliceEndereco(),
        corretagem: this.corretagem,
        apoliceIof: this.apoliceIof,
        premioTotalEndosso: this.premioTotalEndosso,
        valorRestituicao: this.valorRestituicao,
        totalPremio: this.totalPremio,
        idParcelamento: this.idParcelamento,
        idFormaPagamento: this.idFormaPagamento,
        dataPrimeiraParcela: this.dataPrimeiraParcela,
        conteudoPlanilha: this.conteudoPlanilha,
        idRascunhoEndosso: this.idRascunhoEndosso,
        uuidRevisao: this.uuidRevisao,
        naoCalcularItens: this.naoCalcularItens,
        percCondicaoComercial: this.condicaoComercial,
        idTipoCondicao: this.idTipoCondicao,
        idStatusEndosso: this.idStatusEndosso,
        idTipoPessoa: this.idTipoPessoa,
        proponenteCnpj: this.proponenteCnpj,
        proponenteRazaoSocial: this.proponenteRazaoSocial,
        idEndossoRascunhoSalvo: this.idEndossoRascunhoSalvo,
        nomeCorretorParceiro: this.apolice.nomeUsuarioCorretor,
        numeroReserva: this.apolice.numeroReserva,
        tipoEndossoSolicitado: this.retornarTipoEndosso(this.idTipoEndosso),
      });
    },

    retornarTipoEndosso(tipoEndosso) {
      switch(tipoEndosso) {
        case 1:
          return 'Cobrança';
        case 3:
          return 'Exclusão';
        case 5:
          return 'Substituição';
        default:
          return null;
      }
    },

    obterApoliceEndereco() {
      return {
        enderecoCep: this.apoliceEndereco.enderecoCep,
        enderecoRua: this.apoliceEndereco.enderecoRua,
        enderecoNumero: this.apoliceEndereco.enderecoNumero,
        enderecoComplemento: this.apoliceEndereco.enderecoComplemento,
        enderecoBairro: this.apoliceEndereco.enderecoBairro,
        enderecoCidade: this.apoliceEndereco.enderecoCidade,
        enderecoUf: this.apoliceEndereco.enderecoUf,
        enderecoTelefone: this.apoliceEndereco.enderecoTelefone,
        enderecoEmail: this.apoliceEndereco.enderecoEmail
      };
    },

    redirecionarParaPagina() {
      if (this.endossoSubstituicao) {
        this.$router.push(
          `/corretor/gridEndossoVeiculoSubstituicaoCorretor?id=${
            this.idApolice
          }${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${
            this.idTipoEndosso
          }${
            this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
          }${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }${
            this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
          }`
        );
      } else if (this.endossoExclusao) {
        this.$router.push(
          `/corretor/gridVeiculosExclusao?id=${
            this.idApolice
          }${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${
            this.idTipoEndosso
          }${
            this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
          }${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }${
            this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
          }`
        );
      } else {
        this.$router.push(
          `/corretor/gridVeiculos?id=${
            this.idApolice
          }${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${
            this.idTipoEndosso
          }${
            this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
          }${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }${
            this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
          }`
        );
      }
    }
  }
};
</script>
<style scoped>
.button-message {
  text-transform: capitalize;
  font-weight: 400;
  font-size: 12px;
}
.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;
  font-weight: bold;
}
.wrapper-bolha-info {
  position: absolute;
  background-color: #aaaaaa;
  width: 400px;
  border-radius: 8px;
  padding: 14px;
  top: -30px;
  right: -312px;
  transition: 0.4s ease-in;
  display: block;
}

.wrapper-bolha-info::before {
  position: absolute;
  content: "";
  width: 0px;
  height: 0px;
  border-top: 10px solid transparent;
  border-right: 10px solid #aaaaaa;
  border-bottom: 10px solid transparent;
  border-left: 10px solid transparent;
  top: 22%;
  left: -18px;
}
.wrapper-bolha-info p {
  color: #fff;
  font-size: 15px;
}
.checkbox-calculo-itens {
  position: relative;
  justify-content: space-between;
  align-items: flex-start;
}
.checkbox-calculo-itens .theme--dark.v-icon {
  color: #aaaaaa;
  display: block;
  width: 20%;
}
.textblack {
  color: #757575;
}
.color {
  background-color: #eaeaea;
}
.headline {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/InfoEndossoCorretor.vue